import { DistributionBlockTypeEnum } from '../enums/distribution-block-type.enum';

/**
 * A mapping of blockTypes to its properties and their related generalStyle properties
 */
export const distributionBlockToGeneralStyle = new Map<DistributionBlockTypeEnum, Map<string, string>>(
    [
        [
            DistributionBlockTypeEnum.text,
            new Map<string, string>(
                [
                    ['styles.styleState', 'TEXT.styleState'],
                    ['styles.displayStyleState', 'TEXT.displayStyleState'],
                    ['styles.color', 'TEXT.color'],
                    ['styles.fontFamily', 'TEXT.fontFamily'],
                    ['styles.fontSize', 'TEXT.fontSize'],
                    ['styles.italics', 'TEXT.italics'],
                    ['styles.underlined', 'TEXT.underlined'],
                    ['styles.bold', 'TEXT.bold'],
                    ['styles.alignment', 'TEXT.alignment'],
                    ['styles.backgroundColor', 'TEXT.backgroundColor'],
                    ['styles.padding', 'TEXT.padding']
                ]
            )
        ],
        [
            DistributionBlockTypeEnum.title,
            new Map<string, string>(
                [
                    ['styles.styleState', 'TITLE.styleState'],
                    ['styles.displayStyleState', 'TITLE.displayStyleState'],
                    ['styles.color', 'TITLE.color'],
                    ['styles.fontFamily', 'TITLE.fontFamily'],
                    ['styles.fontSize', 'TITLE.fontSize'],
                    ['styles.italics', 'TITLE.italics'],
                    ['styles.underlined', 'TITLE.underlined'],
                    ['styles.bold', 'TITLE.bold'],
                    ['styles.alignment', 'TITLE.alignment'],
                    ['styles.backgroundColor', 'TITLE.backgroundColor'],
                    ['styles.padding', 'TITLE.padding']
                ]
            )
        ],
        [
            DistributionBlockTypeEnum.image,
            new Map<string, string>(
                [
                    ['styles.styleState', 'IMAGE.styleState'],
                    ['styles.displayStyleState', 'IMAGE.displayStyleState'],
                    ['styles.color', 'IMAGE.color'],
                    ['styles.fontFamily', 'IMAGE.fontFamily'],
                    ['styles.fontSize', 'IMAGE.fontSize'],
                    ['styles.italics', 'IMAGE.italics'],
                    ['styles.underlined', 'IMAGE.underlined'],
                    ['styles.bold', 'IMAGE.bold'],
                    ['styles.alignment', 'IMAGE.alignment'],
                    ['styles.imageAlignment', 'IMAGE.imageAlignment'],
                    ['styles.width', 'IMAGE.width'],
                    ['styles.backgroundColor', 'IMAGE.backgroundColor'],
                    ['styles.padding', 'IMAGE.padding']
                ]
            )
        ],
        [
            DistributionBlockTypeEnum.divider,
            new Map<string, string>(
                [
                    ['styles.styleState', 'DIVIDER.styleState'],
                    ['styles.displayStyleState', 'DIVIDER.displayStyleState'],
                    ['styles.dividerColor', 'DIVIDER.dividerColor'],
                    ['styles.defaultReference', 'DIVIDER.defaultReference'],
                    ['styles.height', 'DIVIDER.height'],
                    ['styles.marginBottom', 'DIVIDER.marginBottom'],
                    ['styles.marginTop', 'DIVIDER.marginTop'],
                    ['styles.backgroundColor', 'DIVIDER.backgroundColor'],
                    ['styles.padding', 'DIVIDER.padding']
                ]
            )
        ],
        [
            DistributionBlockTypeEnum.button,
            new Map<string, string>(
                [
                    ['styles.styleState', 'BUTTON.styleState'],
                    ['styles.displayStyleState', 'BUTTON.displayStyleState'],
                    ['styles.buttonColor', 'BUTTON.buttonColor'],
                    ['styles.buttonBackgroundColor', 'BUTTON.buttonBackgroundColor'],
                    ['styles.fontColor', 'BUTTON.fontColor'],
                    ['styles.fontFamily', 'BUTTON.fontFamily'],
                    ['styles.fontSize', 'BUTTON.fontSize'],
                    ['styles.italics', 'BUTTON.italics'],
                    ['styles.underlined', 'BUTTON.underlined'],
                    ['styles.bold', 'BUTTON.bold'],
                    ['styles.buttonAlignment', 'BUTTON.buttonAlignment'],
                    ['styles.buttonShape', 'BUTTON.buttonShape'],
                    ['styles.padding', 'BUTTON.padding']
                ]
            )
        ],
        [
            DistributionBlockTypeEnum.link,
            new Map<string, string>(
                [
                    ['styles.styleState', 'LINK.styleState'],
                    ['styles.displayStyleState', 'LINK.displayStyleState'],
                    ['styles.color', 'LINK.color'],
                    ['styles.fontFamily', 'LINK.fontFamily'],
                    ['styles.fontSize', 'LINK.fontSize'],
                    ['styles.italics', 'LINK.italics'],
                    ['styles.underlined', 'LINK.underlined'],
                    ['styles.bold', 'LINK.bold'],
                    ['styles.alignment', 'LINK.alignment'],
                    ['styles.backgroundColor', 'LINK.backgroundColor'],
                    ['styles.padding', 'LINK.padding'],
                    ['styles.iconColor', 'LINK.iconColor'],
                    ['styles.iconSize', 'LINK.iconSize'],
                    ['styles.iconShape', 'LINK.iconShape'],
                    ['styles.displayOption', 'LINK.displayOption'],
                    ['styles.layoutOption', 'LINK.layoutOption'],
                    ['styles.iconBackgroundColor', 'LINK.iconBackgroundColor'],
                ]
            )
        ],
        [
            DistributionBlockTypeEnum.oneColumnLayout,
            new Map<string, string>(
                [
                    ['styles.styleState', 'ONE_COLUMN_LAYOUT.styleState'],
                    ['styles.displayStyleState', 'ONE_COLUMN_LAYOUT.displayStyleState'],
                    ['styles.backgroundColor', 'ONE_COLUMN_LAYOUT.backgroundColor'],
                    ['styles.padding', 'ONE_COLUMN_LAYOUT.padding']
                ]
            )
        ],
        [
            DistributionBlockTypeEnum.twoColumnLayout,
            new Map<string, string>(
                [
                    ['styles.styleState', 'TWO_COLUMN_LAYOUT.styleState'],
                    ['styles.displayStyleState', 'TWO_COLUMN_LAYOUT.displayStyleState'],
                    ['styles.displayRatio', 'TWO_COLUMN_LAYOUT.displayRatio'],
                    ['styles.width', 'TWO_COLUMN_LAYOUT.width'],
                    ['styles.backgroundColor', 'TWO_COLUMN_LAYOUT.backgroundColor'],
                    ['styles.verticalAlignment', 'TWO_COLUMN_LAYOUT.verticalAlignment'],
                    ['styles.padding', 'TWO_COLUMN_LAYOUT.padding'],
                    ['styles.columnSpacing', 'TWO_COLUMN_LAYOUT.columnSpacing']
                ]
            )
        ],
        [
            DistributionBlockTypeEnum.threeColumnLayout,
            new Map<string, string>(
                [
                    ['styles.styleState', 'THREE_COLUMN_LAYOUT.styleState'],
                    ['styles.displayStyleState', 'THREE_COLUMN_LAYOUT.displayStyleState'],
                    ['styles.displayRatio', 'THREE_COLUMN_LAYOUT.displayRatio'],
                    ['styles.width', 'THREE_COLUMN_LAYOUT.width'],
                    ['styles.backgroundColor', 'THREE_COLUMN_LAYOUT.backgroundColor'],
                    ['styles.verticalAlignment', 'THREE_COLUMN_LAYOUT.verticalAlignment'],
                    ['styles.padding', 'THREE_COLUMN_LAYOUT.padding'],
                    ['styles.columnSpacing', 'THREE_COLUMN_LAYOUT.columnSpacing']
                ]
            )
        ]
    ]
);
